import React from 'react';
import { Checkbox as AntdCheckbox } from 'antd';

import classes from './CheckboxGroup.module.scss';

const options = [
  { label: 'Apple', value: 'Apple' },
  { label: 'Pear', value: 'Pear' },
  { label: 'Orange', value: 'Orange' },
];

const CheckboxGroup = props => {
  const { onChange = () => {}, defaultValue = ['Pear'], ...other } = props;
  return (
    <AntdCheckbox.Group
      {...other}
      options={options}
      defaultValue={defaultValue}
      onChange={onChange}
      className={classes.wrapper}
    />
  );
};

export default CheckboxGroup;
